import { useNavigate } from "react-router-dom";
import { FormEvent, useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import camelcaseKeys from "camelcase-keys";
import { Button, ButtonBase, Grid, TextField } from "@mui/material";

import LOGO from "../../semiauth.logo.png";
import Spinner from "../utils/Spinner";
import { useAuth } from "./AuthProvider";
import { useVaultMe } from "../../hooks/vault/base";

const Welcome = () => {
  // const darkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const auth = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const me = useVaultMe();

  const handleWelcome = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // attempt profile search
    me.mutate(email);
  };

  useEffect(() => {
    if (auth.auth) navigate("/connect");
  }, [auth.auth]);

  useEffect(() => {
    if (me.isSuccess) {
      const user = camelcaseKeys(me.data.data.data, { deep: true });
      auth.setUser(user);

      navigate("/signin");
    }
  }, [me.isSuccess]);

  useEffect(() => {
    document.title = "[semiauth] | welcome";
  }, []); // run once on mount

  return (
    <Container
      maxWidth="sm"
      component="main"
      sx={{
        display: "flex",
        textAlign: "center",
        alignItems: "center",
        marginBlock: "auto",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img src={LOGO} alt="[semiauth] logo" className="logo" />

        <Box component="form" onSubmit={handleWelcome} noValidate>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            type="email"
            name="email"
            label="Email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={!email}
            sx={{ my: 2 }}
          >
            {me.isPending ? <Spinner sx={{ mx: 7 }} /> : "Continue"}
          </Button>

          <Grid container justifyContent="flex-start">
            <Grid item xs textAlign="right">
              <ButtonBase onClick={() => navigate("/signup")}>
                Sign up
              </ButtonBase>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default Welcome;
